import { Question } from 'components';
import { QuizQuestions } from 'graphql/queries/types/QuizQuestions';
import { useQuizFocus } from 'hooks';
import { useCallback, useEffect, useState, CSSProperties } from 'react';
import { Slide } from './slide';

interface Props {
    quizQuestions: QuizQuestions;
    eventLogoUrl?: string | null;
    backgroundStyles: CSSProperties;
    fontStyles: CSSProperties;
    hoverMenu?: React.ReactNode;
    startingSlideIndex?: number
    finishQuiz: () => void;
    onSlideIndexChange?: (index: number) => void;
}

export const QuestionSlides = (props: Props) => {
    const questionCount = props.quizQuestions.quiz_master_quizzes_by_pk!.questions.length;
    const questions = props.quizQuestions.quiz_master_quizzes_by_pk!.questions;
    const [currentIndex, setIndex] = useState(props.startingSlideIndex ?? 0);
    useQuizFocus();

    const question = questions[currentIndex];
    // console.log('current question', question, 'index', currentIndex, 'all questions', props.quizQuestions)

    const nextQuestion = useCallback(() => {
        if (currentIndex === questionCount - 1) {
            props.finishQuiz();
            return;
        }

        const newIndex = currentIndex + 1;
        setIndex(newIndex);
        if (props.onSlideIndexChange) {
            props.onSlideIndexChange(newIndex);
        }
    }, [currentIndex, questionCount, props]);

    const previousQuestion = useCallback(() => {
        if (currentIndex > 0) {
            const newIndex = currentIndex - 1;
            setIndex(newIndex);
            if (props.onSlideIndexChange) {
                props.onSlideIndexChange(newIndex);
            }
        }
    }, [currentIndex, props]);

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'ArrowLeft') {
                previousQuestion();
            }
            if (event.key === 'ArrowRight') {
                nextQuestion();
            }
        };
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [nextQuestion, previousQuestion]);

    return (
        <>
            <Slide
                headerText={props.quizQuestions.quiz_master_quizzes_by_pk?.name}
                slideNumber={currentIndex + 1}
                slideCount={questionCount}
                eventLogoUrl={props.eventLogoUrl}
                previousClick={previousQuestion}
                nextClick={nextQuestion}
                backgroundStyles={props.backgroundStyles}
                fontStyles={props.fontStyles}
            >
                <Question question={question} showMultipleChoiceOptions={true} baseClassName="question" />
            </Slide>
            {props.hoverMenu}
        </>
    );
};
